"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactMasonryCss = _interopRequireDefault(require("react-masonry-css"));

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Skeleton = function Skeleton(_ref) {
  var breakPoints = _ref.breakPoints,
      css = _ref.css,
      skeletonItems = _ref.skeletonItems;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-gallery-03", css.root)
  }, /*#__PURE__*/_react.default.createElement(_reactMasonryCss.default, {
    breakpointCols: breakPoints,
    className: "mco-gallery-03__grid",
    columnClassName: "mco-gallery-03__column"
  }, _toConsumableArray(Array(skeletonItems)).map(function (x, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: i
    }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
      className: css.skeleton,
      variant: "rect"
    }));
  })));
};

var _default = Skeleton;
exports.default = _default;